import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getBondNameByBondType, getTypeBondByDragging } from '../functions';
import { ComponentsDispatch, RootState } from '../store';
import { setterGantItems } from '../store/slices/gantItemsSlice';
import { DraggableGantType, ItemType, MappingItemIdIndexType } from '../types';

const useControllerGantBond = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const currentDropBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDropBond);
    const currentDragBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDragBond);
    const dragging = useSelector<RootState, DraggableGantType>((state) => state.gantDraggable.dragging);
    const draggingDrop = useSelector<RootState, DraggableGantType>((state) => state.gantDraggable.draggingDrop);
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);

    useEffect(() => {
        if (currentDragBond && currentDropBond) {
            const typeBond = getTypeBondByDragging(dragging, draggingDrop);
            const newItems = [...itemsList];

            const setNewBonds = (currentItemBondId: string, isParentItem?: boolean) => {
                const oldItem = newItems[mappingItemIdIndex[currentItemBondId]];
                const bondName: keyof ItemType = getBondNameByBondType(typeBond, isParentItem);
                const newBonds = new Set(oldItem[bondName] as string[]);
                newBonds.add(isParentItem ? currentDropBond.id : currentDragBond.id);

                newItems[mappingItemIdIndex[currentItemBondId]] = {
                    ...oldItem,
                    [bondName]: [...newBonds],
                };
            };

            setNewBonds(currentDragBond.id, true);
            setNewBonds(currentDropBond.id);

            dispatch(setterGantItems({ itemsList: newItems }));
        }
    }, [currentDropBond]);
};

export default useControllerGantBond;
